export default __webpack_public_path__ + "static/media/img-50-sphinx.e399594b.jpg";